import { z } from "zod";

/**
 * One booked pick: the article taken, the shelf it came off, and how many.
 *
 * The location is required rather than derived, because an article stocked at two shelves of the
 * same zone is a choice the picker makes with their hands — the balance has to fall on the shelf
 * they actually emptied, or the next picker walks to the wrong one.
 */
export const postSuborderPickJsonSchema = z.object({
	articleId: z.uuid(),
	warehouseLocationId: z.uuid(),
	quantity: z.coerce.number().int().positive(),
});

export type PostSuborderPickJsonSchema = z.infer<typeof postSuborderPickJsonSchema>;
